/**
 * Canonical admin configuration.
 * Single source of truth — all API routes and client code should import from here.
 */

/** Internal Cardinal staff — grants platform admin (Organizations switcher, JWT org override, etc.) */
export const ADMIN_DOMAINS = ["trycardinal.ai"] as const

export const ADMIN_EMAILS = [] as const

export const INTERNAL_API_KEY_HEADER = "x-internal-key"

/** Stytch B2B custom roles. Single source of truth for role IDs. */
export enum StytchB2BRole {
    CARDINAL_SUPER_ADMIN = "cardinal_super_admin",
    STYTCH_ADMIN = "stytch_admin",
}

/**
 * MIGRATION AUX — remove after Stytch B2B migration is complete.
 *
 * During the B2C → B2B migration, both auth flows coexist. The B2B flow lives
 * under /b2b/* with its own Stytch B2B providers (StytchB2BClientProvider,
 * B2BAuthProvider). These routes must NOT be affected by B2C auth logic — e.g.
 * the OrganizationContext redirect to /login — because B2B users won't have a
 * B2C session and that redirect would break their flow.
 *
 * Once migration is done and all routes use B2B auth, this helper and its
 * call sites should be removed.
 */
export function isB2BRoute(): boolean {
    if (typeof window === "undefined") return false
    return window.location.pathname.startsWith("/b2b")
}

export function isAdminUser(email: string): boolean {
    const normalized = email.toLowerCase()
    const domain = normalized.split("@").pop() || ""
    return (
        (ADMIN_DOMAINS as readonly string[]).includes(domain) ||
        (ADMIN_EMAILS as readonly string[]).includes(normalized)
    )
}
